export default __webpack_public_path__ + "static/media/Spinner.6ae745ce.svg";